import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchHomePageData } from '../utils/pageData'
import formatDataOfPage from '../lib/formatDataOfPage'

export const updateHomeResponse = createAsyncThunk(
  'commonData/updateHomeResponse',
  async (storeId = '', { rejectWithValue }) => {
    try {
      const page = await fetchHomePageData({ storeId })
      return {
        name: page?.name,
        showFilter: page?.showFilter,
        entity: page?.entity,
        layouts: formatDataOfPage(page?.layouts, 'home'),
      }
    } catch (error) {
      console.error(error)
      return rejectWithValue(error.message || 'Failed to fetch home page data')
    }
  }
)

const initialState = {
  navigationData: [],
  organizationData: {},
  footerData: [],
  homeLayoutData: {},
  announcementData: {},
  loading: false,
  error: null,
}

const commonDataSlice = createSlice({
  name: 'commonData',
  initialState,
  reducers: {
    setCommonData: (state, action) => {
      const {
        navigationData,
        organizationData,
        footerData,
        announcementData,
        homeData,
      } = action.payload
      state.navigationData = navigationData || []
      state.organizationData = organizationData || {}
      state.footerData = footerData || []
      state.announcementData = announcementData || {}
      state.homeLayoutData = homeData || {}
    },
  },
  extraReducers: builder => {
    builder
      .addCase(updateHomeResponse.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(updateHomeResponse.fulfilled, (state, action) => {
        state.loading = false
        state.homeLayoutData = action.payload
      })
      .addCase(updateHomeResponse.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const { setCommonData } = commonDataSlice.actions
export default commonDataSlice.reducer
